import React, { useContext, useEffect, useState } from "react";
import { Redirect } from "react-router";
import { EjariContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import EjariApi from "@eres/ejari-api";
import { dispatchX } from "@my-dld/utils/StoreUtils";
import { showMessage } from "@my-dld/utils/UIUtils";
import { EjariContractDataAction } from "../reducers/EjariContractData";

type PageState = "loading" | "done" | "error" | "invalid";

interface ContractLoaderProps {
}

export type  EjariCtxContractLoader = React.ElementType<ContractLoaderProps>;

const DefaultContractLoader: React.FunctionComponent<ContractLoaderProps> = props => {

	const ctx = useContext( EjariContractContext );
	const [ status, setStatus ] = useState<PageState>( "loading" );
	useEffect( () => {
		const cn = ctx.contractNumber;
		if ( cn ) {
			EjariApi.getContractDetails( cn + "", ctx.activeUserId + "" )
			.then( p => {
				dispatchX( {
					type: EjariContractDataAction.EJARI_CONTRACT_UPDATE_STATE,
					payload: {
						contract: p,
					}
				} );
				setStatus( "done" );
			} ).catch( showMessage );
		} else {
			setStatus( "done" );
		}
		return () => {

		};
	}, [ ctx.contractNumber ] );
	if ( status === "loading" )
		return <div style={ { width: "100%", display: "flex", minHeight: 200, alignItems: "center" } }>
			<SpinnerLoader/>
		</div>;
	if ( status === "invalid" )
		return <Redirect to={ "/mydld" }/>;
	return <React.Fragment>{ props.children }</React.Fragment>;
};
export default DefaultContractLoader;
